<template>
  <div class="bg">
    <!-- 搜索栏 -->
    <div class="top_search_part">
      <div class="search_box">
        <div class="search_item">
          <el-input v-model="customerName" :placeholder="$t('message.custSearchPlaceholder')"></el-input>
        </div>
        <div class="search_btn" @click="searchCustomerName">{{$t('message.searchBtnText')}}</div>
      </div>
      <div class="add_btn" @click="addNewaddressee"><img class="add_icon" src="@/assets/addIcon.svg" />{{$t('message.addAddresseeBtnText')}}</div>
    </div>
    <!-- 搜索栏 -->
    <!-- 列表 -->
    <!-- 地址管理列表 -->
    <div class="content">
      <div class="tableBox">
        <el-table id="addresseeList" :data="addresseeList" style="width: 100%" stripe size="small" header-cell-class-name="tableHeader" cell-class-name="tableBodyer" height="100%">
          <el-table-column :label="$t('message.customTableTitle1')" prop="index" width="85"></el-table-column>
          <el-table-column :label="$t('message.addressNameTitle')" prop="USERNAME" width="120"></el-table-column>
          <el-table-column :label="$t('message.addressPhoneTitle')" prop="userPhone" width="120"></el-table-column>
          <el-table-column :label="$t('message.addresseeNameTitle')" prop="LXR" width="130"></el-table-column>
          <el-table-column :label="$t('message.addresseeCompanyTitle')" prop="GSMC" width="130"></el-table-column>
          <el-table-column :label="$t('message.addresseePhoneTitle')" prop="lxrPhone" width="150"></el-table-column>
          <el-table-column :label="$t('message.provienceAddressTitle')" prop="PROVINCE2" width="100"></el-table-column>
          <el-table-column :label="$t('message.cityAddressTitle')" prop="CITY2" width="120"></el-table-column>
          <el-table-column :label="$t('message.detailAddressTitle')" prop="WLADDRESS" min-width="150"></el-table-column>
          <el-table-column :label="$t('message.addressAddNameTitle')" prop="ADDNAME" width="120"></el-table-column>
          <el-table-column :label="$t('message.addressAddTimeTitle')" prop="addTime" width="170"></el-table-column>
          <el-table-column :label="$t('message.customTableTitle5')" width="150" fixed="right">
            <template slot-scope="scope">
              <div class="operate_btn_box">
                <el-button class="operation_btn updateBtn" type="text" size="small" @click.native.prevent="updateAddressee(scope.row)"></el-button>
                <el-button class="operation_btn delBtn" type="text" size="small" @click.native.prevent="delAddressee(scope.row)"></el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="page_no" :page-sizes="pageSizes" :page-size="page_size" layout="total, sizes, prev, pager, next" :total="totalSize" class="tablePage"></el-pagination>
    </div>
    <!-- 地址管理列表 -->
    <!-- 列表 -->
    <el-dialog :visible.sync="newAddressee" :title="dialogTitle" destroy-on-close :close-on-click-modal="false" center :modal-append-to-body="false" width="50%">
      <div class="dialog_box">
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.addressPhoneTitle')}}</span>
            <input v-model="newUserPhone" class="addItemInput" :placeholder="$t('message.placeholder')" />
          </div>
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.addresseeCompanyTitle')}}</span>
            <input v-model="newAddresseeCompany" class="addItemInput" :placeholder="$t('message.placeholder')" />
          </div>
        </div>
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.addresseeNameTitle')}}</span>
            <input v-model="newAddresseeName" class="addItemInput" :placeholder="$t('message.placeholder')" />
          </div>
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.addresseePhoneTitle')}}</span>
            <input v-model="newAddresseePhone" class="addItemInput" :placeholder="$t('message.placeholder')" />
          </div>
        </div>
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.provienceAddressTitle')}}</span>
            <el-select v-model="newProvienceAddress" :placeholder="$t('message.newCustomerProvince')" class="selectBox">
              <el-option v-for="item in prefecturesList" :key="item.code" :label="item.value" :value="item.value"></el-option>
            </el-select>
          </div>
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.cityAddressTitle')}}</span>
            <input v-model="newCityAddress" class="addItemInput" :placeholder="$t('message.placeholder')" />
          </div>
        </div>
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.detailAddressTitle')}}</span>
            <input v-model="newDetailAddress" class="addItemInput" :placeholder="$t('message.placeholder')" />
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="newAddressee = false">{{$t('message.cancleText')}}</el-button>
          <el-button type="primary" @click="addNewConfirm">{{$t('message.confirmText')}}</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { getCustomerAddressee, setCustomerAddressee, delCustomerAddressee } from '@/api/getData.js'
  import prefectures from '@/js/prefectures.json'
  export default {
    name: 'addresseeManagePage',
    data () {
      return {
        page_no: 1,
        page_size: 10,
        pageSizes: [10, 20, 30, 50, 100],
        totalSize: 0,
        prefecturesList: [],
        addresseeList: [],
        customerName: '',
        newAddressee: false,
        dialogTitle: '',
        newId: 0,
        newUserPhone: '',
        newAddresseeName: '',
        newAddresseeCompany: '', // 收件公司名称
        newAddresseePhone: '',
        newProvienceAddress: '', // 省
        newCityAddress: '', // 市
        newDetailAddress: '', // 详细地址
        newAddresseeAddress: ''
      }
    },
    created() {
      this.prefecturesList = prefectures
      let param = this.$store.state.JHSS_addressee_param
      if (param.PAGE) this.page_no = param.PAGE
      if (param.TYPE) this.page_size = param.TYPE
      if (param.USERNAME) this.customerName = param.USERNAME
      // 查询地址管理
      this.getAddress(param)
    },
    methods: {
      // 查询地址
      async getAddress (param) {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        param = param || {}
        param.ADDUSERID = this.$store.state.JHSS.personalUserid
        param.PAGE = this.page_no
        param.TYPE = this.page_size
        let res = await getCustomerAddressee(param)
        // console.log(res.data)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        // console.log(res.data)
        this.totalSize = res.data.num
        let index = (this.page_no - 1) * this.page_size
        this.addresseeList = res.data.dt.map(item => {
          item.index = ++index
          item.userPhone = item.USERPHONE.replace(/(\d{3})(\d{4})(\d{4})/g, '$1****$3')
          item.lxrPhone = item.LXPHONE.replace(/(\d{3})(\d{4})(\d{4})/g, '$1****$3')
          item.addTime = item.ADDTIME.replace(/T/g, ' ')
          return item
        })
        this.$store.commit('setAddresseeParam', param)
      },
      // 搜索客户姓名
      searchCustomerName () {
        let param = {}
        // 查询客户管理
        param.USERNAME = this.customerName
        this.page_no = 1
        this.getAddress(param)
      },
      // 申请条数
      sizeChange (val) {
        // console.log(val)
        this.page_size = val
        this.page_no = 1
        let param = {}
        param.USERNAME = this.customerName
        this.getAddress(param)
      },
      // 当前页
      currentChange (val) {
        // console.log(val)
        this.page_no = val
        let param = {}
        param.USERNAME = this.customerName
        this.getAddress(param)
      },
      // 添加地址
      addNewaddressee () {
        this.newId = 0
        this.newUserPhone = ''
        this.newAddresseeName = ''
        this.newAddresseeCompany = ''
        this.newAddresseePhone = ''
        this.newProvienceAddress = ''
        this.newCityAddress = ''
        this.newDetailAddress = ''
        // this.newAddresseeAddress = ''
        this.newAddressee = true
        this.dialogTitle = this.$t('message.addAddresseeBtnText')
      },
      // 确定添加地址
      async addNewConfirm () {
        if (!this.newUserPhone) {
          this.$message.error(this.$t('message.addressPhoneTitle'))
        } else if (!this.newAddresseeName) {
          this.$message.error(this.$t('message.addresseeNameTitle'))
        } else if (!this.newAddresseeCompany) {
          this.$message.error(this.$t('message.addresseeCompanyTitle'))
        } else if (!this.newAddresseePhone) {
          this.$message.error(this.$t('message.addresseePhoneTitle'))
        } else if (!this.newProvienceAddress) {
          this.$message.error(this.$t('message.provienceAddressTitle'))
        } else if (!this.newCityAddress) {
          this.$message.error(this.$t('message.cityAddressTitle'))
        } else if (!this.newDetailAddress) {
          this.$message.error(this.$t('message.detailAddressTitle'))
        } else {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          let param = {
            ID: this.newId,
            USERPHONE: this.newUserPhone,
            LXR: this.newAddresseeName,
            GSMC: this.newAddresseeCompany,
            LXPHONE: this.newAddresseePhone,
            PROVINCE2: this.newProvienceAddress,
            CITY2: this.newCityAddress,
            WLADDRESS: this.newDetailAddress,
            // WLADDRESS: this.newAddresseeAddress,
            ADDUSERID: this.$store.state.JHSS.personalUserid,
            ADDNAME: this.$store.state.JHSS.personalAccount
          }
          // console.log(param)
          let res = await setCustomerAddressee(param)
          loading.close()
          if (res.status !== 200) {
            this.$message.error('network error：' + res.status)
            return
          }
          // console.log(res.data)
          if (res.data.result !== '1') {
            this.$message.error(res.data.message)
          } else {
            this.newAddressee = false
            this.page_no = 1
            this.getAddress()
          }
        }
      },
      // 修改客户地址
      updateAddressee (obj) {
        // console.log(obj)
        this.newAddressee = true
        this.dialogTitle = this.$t('message.updateAddresseeBtnText')
        this.newId = obj.ID
        this.newUserPhone = obj.USERPHONE
        this.newAddresseeName = obj.LXR
        this.newAddresseeCompany = obj.GSMC
        this.newAddresseePhone = obj.LXPHONE
        // this.newAddresseeAddress = obj.WLADDRESS
        this.newProvienceAddress = obj.PROVINCE2
        this.newCityAddress = obj.CITY2
        this.newDetailAddress = obj.WLADDRESS
      },
      // 删除客户地址
      delAddressee (obj) {
        // console.log(obj)
        this.$confirm(this.$t('message.addresseePrompt'), this.$t('message.promptTitle'), {
          closeOnClickModal: false,
          confirmButtonText: this.$t('message.confirmText'),
          cancelButtonText: this.$t('message.cancleText')
        }).then(() => {
          this.del(obj.ID)
        }).catch(() => {
          this.$message(this.$t('message.canclePrompt'));
        });
      },
      async del (id) {
        let param = { ID: id }
        let res = await delCustomerAddressee(param)
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        if (res.data.result !== '1') {
          this.$message.error(res.data.message)
        } else {
          let param = { USERNAME: this.customerName }
          this.getAddress(param)
        }
      }
    }
  }
</script>

<style scoped>
.selectBox {
  width: 280px;
}
/deep/ .selectBox .el-input__inner {
  min-height: 46px;
  border: 1px solid #979797;
  border-radius: 4px;
  text-align: left;
  font-size: 18px;
  color: #666666;
}
.addItemInput {
  width: 280px;
  min-height: 46px;
  border: 1px solid #979797;
  border-radius: 4px;
  padding: 0 11px;
  font-size: 18px;
  color: #666666;
  text-align: left;
}
</style>
